import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "frame" }
const _hoisted_2 = { class: "frame__inner container" }
const _hoisted_3 = { class: "frame__header" }
const _hoisted_4 = { class: "frame__body" }
const _hoisted_5 = { class: "service-list" }
const _hoisted_6 = { class: "service-list__inner" }
const _hoisted_7 = { class: "service-list__search" }
const _hoisted_8 = {
  key: 1,
  class: "service-list__cards"
}
const _hoisted_9 = {
  key: 0,
  class: "not-found"
}
const _hoisted_10 = { class: "sl-card__inner" }
const _hoisted_11 = { class: "sl-card__icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "sl-card__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_search = _resolveComponent("ap-search")!
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Back, {
          title: _ctx.catalogName,
          redirect: _ctx.redirect
        }, null, 8, ["title", "redirect"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ap_search, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                placeholder: _ctx.t('services.search_placeholder'),
                onInput: _ctx.filter
              }, null, 8, ["modelValue", "placeholder", "onInput"])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ap_loader, {
                  key: 0,
                  class: "service-list__loader"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (!_ctx.catalogsServices.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Ничего не найдено "))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.catalogsServices, (service) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: service.id,
                          class: "sl-card"
                        }, [
                          _createVNode(_component_router_link, {
                            to: { name: 'service', 
                         params: { 
                           id: service.id, 
                           name: service.name, 
                           catalogName: _ctx.catalogName, 
                           catalogId: service.catalogs[0]
                         }}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("img", {
                                    src: service.icon ? service.icon : _ctx.defaultServiceIcon  ,
                                    alt: "icon "
                                  }, null, 8, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(service.name), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                ]))
          ])
        ])
      ])
    ])
  ]))
}